// This file is auto-generated by @hey-api/openapi-ts

export const $All_Contracts_For_Estimated_Price_Update = {
  properties: {
    electricity: {
      $ref: "#/components/schemas/ElectricityContractCategoriesByProduct",
    },
    emissions: {
      $ref: "#/components/schemas/EmissionContractCategories",
    },
    gas: {
      $ref: "#/components/schemas/GasContractCategories",
    },
    sparkspread: {
      $ref: "#/components/schemas/SparkSpreadContractCategoriesByProduct",
    },
  },
  type: "object",
  required: ["electricity", "emissions", "gas", "sparkspread"],
  title: "All_Contracts_For_Estimated_Price_Update",
} as const;

export const $BlockedWindowIn = {
  properties: {
    start: {
      type: "string",
      format: "time",
      title: "Start",
    },
    end: {
      type: "string",
      format: "time",
      title: "End",
    },
  },
  type: "object",
  required: ["start", "end"],
  title: "BlockedWindowIn",
} as const;

export const $Body_create_superuser_superusers__post = {
  properties: {
    user_in: {
      $ref: "#/components/schemas/UserBase",
    },
    client_links: {
      items: {
        $ref: "#/components/schemas/ClientLinkCreate-Input",
      },
      type: "array",
      title: "Client Links",
    },
  },
  type: "object",
  required: ["user_in", "client_links"],
  title: "Body_create_superuser_superusers__post",
} as const;

export const $Body_create_upload_file_price_update_uploadfile__post = {
  properties: {
    file: {
      type: "string",
      format: "binary",
      title: "File",
    },
  },
  type: "object",
  required: ["file"],
  title: "Body_create_upload_file_price_update_uploadfile__post",
} as const;

export const $Body_create_user_users__post = {
  properties: {
    user_in: {
      $ref: "#/components/schemas/UserBase",
    },
    client_links: {
      items: {
        $ref: "#/components/schemas/ClientLinkCreate-Input",
      },
      type: "array",
      title: "Client Links",
    },
  },
  type: "object",
  required: ["user_in", "client_links"],
  title: "Body_create_user_users__post",
} as const;

export const $Body_update_superuser_superusers__user_id__patch = {
  properties: {
    user_in: {
      $ref: "#/components/schemas/UserUpdate",
    },
    client_links: {
      items: {
        $ref: "#/components/schemas/ClientLinkCreate-Input",
      },
      type: "array",
      title: "Client Links",
    },
  },
  type: "object",
  required: ["user_in", "client_links"],
  title: "Body_update_superuser_superusers__user_id__patch",
} as const;

export const $Body_update_user_client_link_user_client_links__user_id___client_id__patch = {
  properties: {
    permissions: {
      items: {
        $ref: "#/components/schemas/PermissionsEnum",
      },
      type: "array",
      title: "Permissions",
    },
    estimated_price_update_preferences: {
      anyOf: [
        {
          $ref: "#/components/schemas/EstimatedPriceUpdatePreferenceRecord-Input",
        },
        {
          type: "null",
        },
      ],
    },
    cc_recipients: {
      anyOf: [
        {
          items: {
            type: "string",
            format: "email",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Cc Recipients",
    },
    bcc_recipients: {
      anyOf: [
        {
          items: {
            type: "string",
            format: "email",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Bcc Recipients",
    },
  },
  type: "object",
  required: ["permissions"],
  title: "Body_update_user_client_link_user_client_links__user_id___client_id__patch",
} as const;

export const $Body_update_user_users__user_id__patch = {
  properties: {
    user_in: {
      $ref: "#/components/schemas/UserUpdate",
    },
    client_links: {
      items: {
        $ref: "#/components/schemas/ClientLinkCreate-Input",
      },
      type: "array",
      title: "Client Links",
    },
  },
  type: "object",
  required: ["user_in", "client_links"],
  title: "Body_update_user_users__user_id__patch",
} as const;

export const $BuildSlicesRequest = {
  properties: {
    delivery_date: {
      type: "string",
      format: "date",
      title: "Delivery Date",
    },
    blocked_windows: {
      items: {
        $ref: "#/components/schemas/BlockedWindowIn",
      },
      type: "array",
      maxItems: 10,
      title: "Blocked Windows",
    },
  },
  type: "object",
  required: ["delivery_date"],
  title: "BuildSlicesRequest",
} as const;

export const $BuildSlicesResponse = {
  properties: {
    total_inserts: {
      type: "integer",
      title: "Total Inserts",
    },
  },
  type: "object",
  required: ["total_inserts"],
  title: "BuildSlicesResponse",
} as const;

export const $CancelPtuOrdersRequest = {
  properties: {
    delivery_date: {
      type: "string",
      format: "date",
      title: "Delivery Date",
    },
    start: {
      type: "string",
      format: "time",
      title: "Start",
    },
    end: {
      type: "string",
      format: "time",
      title: "End",
    },
  },
  type: "object",
  required: ["delivery_date", "start", "end"],
  title: "CancelPtuOrdersRequest",
} as const;

export const $CancelPtuOrdersResponse = {
  properties: {
    cancelled: {
      type: "integer",
      title: "Cancelled",
    },
    signals_reset: {
      type: "integer",
      title: "Signals Reset",
    },
  },
  type: "object",
  required: ["cancelled", "signals_reset"],
  title: "CancelPtuOrdersResponse",
} as const;

export const $CheckSignalsRequest = {
  properties: {
    ids: {
      items: {
        type: "integer",
      },
      type: "array",
      minItems: 1,
      title: "Ids",
    },
  },
  type: "object",
  required: ["ids"],
  title: "CheckSignalsRequest",
} as const;

export const $ClientCreate = {
  properties: {
    client_code: {
      type: "string",
      maxLength: 10,
      title: "Client Code",
    },
    client_name: {
      type: "string",
      maxLength: 255,
      title: "Client Name",
    },
  },
  type: "object",
  required: ["client_code", "client_name"],
  title: "ClientCreate",
} as const;

export const $ClientLinkCreate_Input = {
  properties: {
    client_id: {
      type: "integer",
      title: "Client Id",
    },
    permissions: {
      items: {
        anyOf: [
          {
            $ref: "#/components/schemas/PermissionsEnum",
          },
          {
            $ref: "#/components/schemas/SuperUserPermissionsEnum",
          },
        ],
      },
      type: "array",
      title: "Permissions",
    },
    estimated_price_update_preferences: {
      anyOf: [
        {
          $ref: "#/components/schemas/EstimatedPriceUpdatePreferenceRecord-Input",
        },
        {
          type: "null",
        },
      ],
    },
    cc_recipients: {
      anyOf: [
        {
          items: {
            type: "string",
            format: "email",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Cc Recipients",
    },
    bcc_recipients: {
      anyOf: [
        {
          items: {
            type: "string",
            format: "email",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Bcc Recipients",
    },
  },
  type: "object",
  required: ["client_id", "permissions", "estimated_price_update_preferences", "cc_recipients", "bcc_recipients"],
  title: "ClientLinkCreate",
} as const;

export const $ClientLinkCreate_Output = {
  properties: {
    client_id: {
      type: "integer",
      title: "Client Id",
    },
    permissions: {
      items: {
        anyOf: [
          {
            $ref: "#/components/schemas/PermissionsEnum",
          },
          {
            $ref: "#/components/schemas/SuperUserPermissionsEnum",
          },
        ],
      },
      type: "array",
      title: "Permissions",
    },
    estimated_price_update_preferences: {
      anyOf: [
        {
          $ref: "#/components/schemas/EstimatedPriceUpdatePreferenceRecord-Output",
        },
        {
          type: "null",
        },
      ],
    },
    cc_recipients: {
      anyOf: [
        {
          items: {
            type: "string",
            format: "email",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Cc Recipients",
    },
    bcc_recipients: {
      anyOf: [
        {
          items: {
            type: "string",
            format: "email",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Bcc Recipients",
    },
  },
  type: "object",
  required: ["client_id", "permissions", "estimated_price_update_preferences", "cc_recipients", "bcc_recipients"],
  title: "ClientLinkCreate",
} as const;

export const $ClientPublic = {
  properties: {
    id: {
      type: "integer",
      title: "Id",
    },
    client_code: {
      type: "string",
      title: "Client Code",
    },
    client_name: {
      type: "string",
      title: "Client Name",
    },
  },
  type: "object",
  required: ["id", "client_code", "client_name"],
  title: "ClientPublic",
} as const;

export const $ClientPublicWithUsers = {
  properties: {
    id: {
      type: "integer",
      title: "Id",
    },
    client_code: {
      type: "string",
      title: "Client Code",
    },
    client_name: {
      type: "string",
      title: "Client Name",
    },
    users: {
      items: {
        $ref: "#/components/schemas/UserPublic",
      },
      type: "array",
      title: "Users",
    },
  },
  type: "object",
  required: ["id", "client_code", "client_name", "users"],
  title: "ClientPublicWithUsers",
} as const;

export const $Clients = {
  properties: {
    ClientName: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Clientname",
    },
    ClientName_short: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Clientname Short",
    },
    TraderGroup: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Tradergroup",
    },
    Activity: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Activity",
    },
    Account: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Account",
    },
    Settle_of_Electricity: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Settle Of Electricity",
    },
    Settle_of_Gas: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Settle Of Gas",
    },
    Settle_of_LEBA: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Settle Of Leba",
    },
    BTW: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Btw",
    },
    APX: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Apx",
    },
    Onbalans: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Onbalans",
    },
    Futures: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Futures",
    },
    Energiebelasting: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Energiebelasting",
    },
    Handelskosten: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Handelskosten",
    },
    Adres: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Adres",
    },
    Postcode: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Postcode",
    },
    Woonplaats: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Woonplaats",
    },
    Contactpersoon: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Contactpersoon",
    },
    LEI: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Lei",
    },
    FeeSchedule: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Feeschedule",
    },
    APXFee: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Apxfee",
    },
    Debiteurnummer: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Debiteurnummer",
    },
    KASpv: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Kaspv",
    },
    factuurmail1: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Factuurmail1",
    },
    factuurmail2: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Factuurmail2",
    },
    factuurmail3: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Factuurmail3",
    },
    Pvfee: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Pvfee",
    },
    IntradayFee: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Intradayfee",
    },
    KortetermijnFee: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Kortetermijnfee",
    },
    LangetermijnFee: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Langetermijnfee",
    },
    Grootboekrekening: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Grootboekrekening",
    },
    Voordeel: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Voordeel",
    },
    Combined: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Combined",
    },
    EB_invoice: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Eb Invoice",
    },
    Clientsheet: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Clientsheet",
    },
    Portfolio: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Portfolio",
    },
    SU2M: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Su2M",
    },
    GTS_shipper_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Gts Shipper Code",
    },
  },
  type: "object",
  required: [
    "ClientName",
    "ClientName_short",
    "TraderGroup",
    "Activity",
    "Account",
    "Settle_of_Electricity",
    "Settle_of_Gas",
    "Settle_of_LEBA",
    "BTW",
    "APX",
    "Onbalans",
    "Futures",
    "Energiebelasting",
    "Handelskosten",
    "Adres",
    "Postcode",
    "Woonplaats",
    "Contactpersoon",
    "LEI",
    "FeeSchedule",
    "APXFee",
    "Debiteurnummer",
    "KASpv",
    "factuurmail1",
    "factuurmail2",
    "factuurmail3",
    "Pvfee",
    "IntradayFee",
    "KortetermijnFee",
    "LangetermijnFee",
    "Grootboekrekening",
    "Voordeel",
    "Combined",
    "EB_invoice",
    "Clientsheet",
    "Portfolio",
    "SU2M",
    "GTS_shipper_code",
  ],
  title: "Clients",
} as const;

export const $ClientsPublic = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/ClientPublic",
      },
      type: "array",
      title: "Data",
    },
  },
  type: "object",
  required: ["data"],
  title: "ClientsPublic",
} as const;

export const $ClientsWithUsers = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/ClientPublicWithUsers",
      },
      type: "array",
      title: "Data",
    },
    count: {
      type: "integer",
      title: "Count",
    },
  },
  type: "object",
  required: ["data", "count"],
  title: "ClientsWithUsers",
} as const;

export const $ContractNameValidationResult = {
  properties: {
    success: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Success",
    },
    warnings: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Warnings",
    },
    all_contracts: {
      $ref: "#/components/schemas/All_Contracts_For_Estimated_Price_Update",
    },
  },
  type: "object",
  required: ["success", "warnings", "all_contracts"],
  title: "ContractNameValidationResult",
} as const;

export const $ContractRecord = {
  properties: {
    Period: {
      type: "string",
      title: "Period",
    },
    Product: {
      type: "string",
      title: "Product",
    },
    Hours: {
      type: "integer",
      title: "Hours",
    },
    ContractType: {
      type: "string",
      title: "Contracttype",
    },
    First_delivery_date: {
      type: "string",
      format: "date",
      title: "First Delivery Date",
    },
    Last_delivery_date: {
      type: "string",
      format: "date",
      title: "Last Delivery Date",
    },
    ExpiryDate: {
      anyOf: [
        {
          type: "string",
          format: "date",
        },
        {
          type: "null",
        },
      ],
      title: "Expirydate",
    },
  },
  type: "object",
  required: ["Period", "Product", "Hours", "ContractType", "First_delivery_date", "Last_delivery_date", "ExpiryDate"],
  title: "ContractRecord",
} as const;

export const $DeleteAllInnovaAlgoTradesResponse = {
  properties: {
    cancelled: {
      type: "integer",
      title: "Cancelled",
    },
    signals_reset: {
      type: "integer",
      title: "Signals Reset",
    },
    etpa_orders_cancelled_by_intraday_code: {
      type: "integer",
      title: "Etpa Orders Cancelled By Intraday Code",
    },
  },
  type: "object",
  required: ["cancelled", "signals_reset", "etpa_orders_cancelled_by_intraday_code"],
  title: "DeleteAllInnovaAlgoTradesResponse",
} as const;

export const $DeleteEtpaOrdersResponse = {
  properties: {
    deleted: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Deleted",
    },
    failed: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Failed",
    },
    message: {
      type: "string",
      title: "Message",
    },
  },
  type: "object",
  required: ["deleted", "failed", "message"],
  title: "DeleteEtpaOrdersResponse",
} as const;

export const $ElectricityBase = {
  properties: {
    contract: {
      type: "string",
      title: "Contract",
    },
    nl_base_bid: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Nl Base Bid",
    },
    nl_base_ask: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Nl Base Ask",
    },
    nl_peak_bid: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Nl Peak Bid",
    },
    nl_peak_ask: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Nl Peak Ask",
    },
  },
  type: "object",
  required: ["contract"],
  title: "ElectricityBase",
} as const;

export const $ElectricityContractCategories = {
  properties: {
    Months: {
      items: {
        $ref: "#/components/schemas/ContractRecord",
      },
      type: "array",
      title: "Months",
    },
    Quarters: {
      items: {
        $ref: "#/components/schemas/ContractRecord",
      },
      type: "array",
      title: "Quarters",
    },
    Years: {
      items: {
        $ref: "#/components/schemas/ContractRecord",
      },
      type: "array",
      title: "Years",
    },
  },
  type: "object",
  required: ["Months", "Quarters", "Years"],
  title: "ElectricityContractCategories",
} as const;

export const $ElectricityContractCategoriesByProduct = {
  properties: {
    BASE_NL: {
      $ref: "#/components/schemas/ElectricityContractCategories",
    },
    PEAK_NL: {
      $ref: "#/components/schemas/ElectricityContractCategories",
    },
  },
  type: "object",
  required: ["BASE_NL", "PEAK_NL"],
  title: "ElectricityContractCategoriesByProduct",
} as const;

export const $ElectricityContractComparison = {
  properties: {
    contract: {
      type: "string",
      title: "Contract",
    },
    base_bid: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Base Bid",
    },
    base_ask: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Base Ask",
    },
    peak_bid: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Peak Bid",
    },
    peak_ask: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Peak Ask",
    },
    base_settlement_price: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Base Settlement Price",
    },
    peak_settlement_price: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Peak Settlement Price",
    },
    previous_base_bid: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Previous Base Bid",
    },
    previous_base_ask: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Previous Base Ask",
    },
    previous_peak_bid: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Previous Peak Bid",
    },
    previous_peak_ask: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Previous Peak Ask",
    },
  },
  type: "object",
  required: [
    "contract",
    "base_bid",
    "base_ask",
    "peak_bid",
    "peak_ask",
    "base_settlement_price",
    "peak_settlement_price",
  ],
  title: "ElectricityContractComparison",
} as const;

export const $ElectricityPricePreference = {
  properties: {
    M1: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    M2: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    M3: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Q1: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Q2: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Q3: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Q4: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Y1: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Y2: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Y3: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Y4: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  title: "ElectricityPricePreference",
} as const;

export const $EmissionBase = {
  properties: {
    contract: {
      type: "string",
      title: "Contract",
    },
    EUA: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Eua",
    },
  },
  type: "object",
  required: ["contract"],
  title: "EmissionBase",
} as const;

export const $EmissionContractCategories = {
  properties: {
    Spot: {
      items: {
        $ref: "#/components/schemas/ContractRecord",
      },
      type: "array",
      title: "Spot",
    },
    March: {
      items: {
        $ref: "#/components/schemas/ContractRecord",
      },
      type: "array",
      title: "March",
    },
    December: {
      items: {
        $ref: "#/components/schemas/ContractRecord",
      },
      type: "array",
      title: "December",
    },
  },
  type: "object",
  required: ["Spot", "March", "December"],
  title: "EmissionContractCategories",
} as const;

export const $EmissionsContractComparison = {
  properties: {
    contract: {
      type: "string",
      title: "Contract",
    },
    price: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Price",
    },
    settlement_price: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Settlement Price",
    },
    previous_price: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Previous Price",
    },
  },
  type: "object",
  required: ["contract", "price", "settlement_price"],
  title: "EmissionsContractComparison",
} as const;

export const $EmissionsPricePreference = {
  properties: {
    DA: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    NEXT_MARCH: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    NEXT_DEC: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    NEXT_DEC_PLUS_12M: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    NEXT_DEC_PLUS_24M: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    NEXT_DEC_PLUS_36M: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    NEXT_DEC_PLUS_48M: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  title: "EmissionsPricePreference",
} as const;

export const $EstimatedElectricityPricePreference = {
  properties: {
    M1: {
      type: "boolean",
      title: "M1",
      default: false,
    },
    M2: {
      type: "boolean",
      title: "M2",
      default: false,
    },
    M3: {
      type: "boolean",
      title: "M3",
      default: false,
    },
    Q1: {
      type: "boolean",
      title: "Q1",
      default: false,
    },
    Q2: {
      type: "boolean",
      title: "Q2",
      default: false,
    },
    Q3: {
      type: "boolean",
      title: "Q3",
      default: false,
    },
    Q4: {
      type: "boolean",
      title: "Q4",
      default: false,
    },
    Y1: {
      type: "boolean",
      title: "Y1",
      default: false,
    },
    Y2: {
      type: "boolean",
      title: "Y2",
      default: false,
    },
    Y3: {
      type: "boolean",
      title: "Y3",
      default: false,
    },
    Y4: {
      type: "boolean",
      title: "Y4",
      default: false,
    },
  },
  type: "object",
  title: "EstimatedElectricityPricePreference",
} as const;

export const $EstimatedElectricityPricePreferenceRecord = {
  properties: {
    NL_BASE_BID: {
      $ref: "#/components/schemas/EstimatedElectricityPricePreference",
    },
    NL_BASE_ASK: {
      $ref: "#/components/schemas/EstimatedElectricityPricePreference",
    },
    NL_PEAK_BID: {
      $ref: "#/components/schemas/EstimatedElectricityPricePreference",
    },
    NL_PEAK_ASK: {
      $ref: "#/components/schemas/EstimatedElectricityPricePreference",
    },
  },
  type: "object",
  required: ["NL_BASE_BID", "NL_BASE_ASK", "NL_PEAK_BID", "NL_PEAK_ASK"],
  title: "EstimatedElectricityPricePreferenceRecord",
} as const;

export const $EstimatedElectricityPrices = {
  properties: {
    M1: {
      $ref: "#/components/schemas/ElectricityBase",
    },
    M2: {
      $ref: "#/components/schemas/ElectricityBase",
    },
    M3: {
      $ref: "#/components/schemas/ElectricityBase",
    },
    Q1: {
      $ref: "#/components/schemas/ElectricityBase",
    },
    Q2: {
      $ref: "#/components/schemas/ElectricityBase",
    },
    Q3: {
      $ref: "#/components/schemas/ElectricityBase",
    },
    Q4: {
      $ref: "#/components/schemas/ElectricityBase",
    },
    Y1: {
      $ref: "#/components/schemas/ElectricityBase",
    },
    Y2: {
      $ref: "#/components/schemas/ElectricityBase",
    },
    Y3: {
      $ref: "#/components/schemas/ElectricityBase",
    },
    Y4: {
      $ref: "#/components/schemas/ElectricityBase",
    },
  },
  type: "object",
  required: ["M1", "M2", "M3", "Q1", "Q2", "Q3", "Q4", "Y1", "Y2", "Y3", "Y4"],
  title: "EstimatedElectricityPrices",
} as const;

export const $EstimatedEmissionPricePreferenceRecord = {
  properties: {
    DA: {
      type: "boolean",
      title: "Da",
      default: false,
    },
    NEXT_MARCH: {
      type: "boolean",
      title: "Next March",
      default: false,
    },
    NEXT_DEC: {
      type: "boolean",
      title: "Next Dec",
      default: false,
    },
    NEXT_DEC_PLUS_12M: {
      type: "boolean",
      title: "Next Dec Plus 12M",
      default: false,
    },
    NEXT_DEC_PLUS_24M: {
      type: "boolean",
      title: "Next Dec Plus 24M",
      default: false,
    },
    NEXT_DEC_PLUS_36M: {
      type: "boolean",
      title: "Next Dec Plus 36M",
      default: false,
    },
    NEXT_DEC_PLUS_48M: {
      type: "boolean",
      title: "Next Dec Plus 48M",
      default: false,
    },
  },
  type: "object",
  title: "EstimatedEmissionPricePreferenceRecord",
} as const;

export const $EstimatedEmissionPrices = {
  properties: {
    DA: {
      $ref: "#/components/schemas/EmissionBase",
    },
    NEXT_MARCH: {
      $ref: "#/components/schemas/EmissionBase",
    },
    NEXT_DEC: {
      $ref: "#/components/schemas/EmissionBase",
    },
    NEXT_DEC_PLUS_12M: {
      $ref: "#/components/schemas/EmissionBase",
    },
    NEXT_DEC_PLUS_24M: {
      $ref: "#/components/schemas/EmissionBase",
    },
    NEXT_DEC_PLUS_36M: {
      $ref: "#/components/schemas/EmissionBase",
    },
    NEXT_DEC_PLUS_48M: {
      $ref: "#/components/schemas/EmissionBase",
    },
  },
  type: "object",
  required: [
    "DA",
    "NEXT_MARCH",
    "NEXT_DEC",
    "NEXT_DEC_PLUS_12M",
    "NEXT_DEC_PLUS_24M",
    "NEXT_DEC_PLUS_36M",
    "NEXT_DEC_PLUS_48M",
  ],
  title: "EstimatedEmissionPrices",
} as const;

export const $EstimatedGasPricePreference = {
  properties: {
    DA: {
      type: "boolean",
      title: "Da",
      default: false,
    },
    WE: {
      type: "boolean",
      title: "We",
      default: false,
    },
    M1: {
      type: "boolean",
      title: "M1",
      default: false,
    },
    M2: {
      type: "boolean",
      title: "M2",
      default: false,
    },
    M3: {
      type: "boolean",
      title: "M3",
      default: false,
    },
    Q1: {
      type: "boolean",
      title: "Q1",
      default: false,
    },
    Q2: {
      type: "boolean",
      title: "Q2",
      default: false,
    },
    Q3: {
      type: "boolean",
      title: "Q3",
      default: false,
    },
    Q4: {
      type: "boolean",
      title: "Q4",
      default: false,
    },
    Y1: {
      type: "boolean",
      title: "Y1",
      default: false,
    },
    Y2: {
      type: "boolean",
      title: "Y2",
      default: false,
    },
    Y3: {
      type: "boolean",
      title: "Y3",
      default: false,
    },
    Y4: {
      type: "boolean",
      title: "Y4",
      default: false,
    },
    Y5: {
      type: "boolean",
      title: "Y5",
      default: false,
    },
    Win1: {
      type: "boolean",
      title: "Win1",
      default: false,
    },
    Win2: {
      type: "boolean",
      title: "Win2",
      default: false,
    },
    Win3: {
      type: "boolean",
      title: "Win3",
      default: false,
    },
    Win4: {
      type: "boolean",
      title: "Win4",
      default: false,
    },
    Sum1: {
      type: "boolean",
      title: "Sum1",
      default: false,
    },
    Sum2: {
      type: "boolean",
      title: "Sum2",
      default: false,
    },
    Sum3: {
      type: "boolean",
      title: "Sum3",
      default: false,
    },
    Sum4: {
      type: "boolean",
      title: "Sum4",
      default: false,
    },
  },
  type: "object",
  title: "EstimatedGasPricePreference",
} as const;

export const $EstimatedGasPricePreferenceRecord = {
  properties: {
    TTF_BID: {
      $ref: "#/components/schemas/EstimatedGasPricePreference",
    },
    TTF_ASK: {
      $ref: "#/components/schemas/EstimatedGasPricePreference",
    },
  },
  type: "object",
  required: ["TTF_BID", "TTF_ASK"],
  title: "EstimatedGasPricePreferenceRecord",
} as const;

export const $EstimatedGasPrices = {
  properties: {
    DA: {
      $ref: "#/components/schemas/GasBase",
    },
    WE: {
      $ref: "#/components/schemas/GasBase",
    },
    M1: {
      $ref: "#/components/schemas/GasBase",
    },
    M2: {
      $ref: "#/components/schemas/GasBase",
    },
    M3: {
      $ref: "#/components/schemas/GasBase",
    },
    Q1: {
      $ref: "#/components/schemas/GasBase",
    },
    Q2: {
      $ref: "#/components/schemas/GasBase",
    },
    Q3: {
      $ref: "#/components/schemas/GasBase",
    },
    Q4: {
      $ref: "#/components/schemas/GasBase",
    },
    Y1: {
      $ref: "#/components/schemas/GasBase",
    },
    Y2: {
      $ref: "#/components/schemas/GasBase",
    },
    Y3: {
      $ref: "#/components/schemas/GasBase",
    },
    Y4: {
      $ref: "#/components/schemas/GasBase",
    },
    Y5: {
      $ref: "#/components/schemas/GasBase",
    },
    Win1: {
      $ref: "#/components/schemas/GasBase",
    },
    Win2: {
      $ref: "#/components/schemas/GasBase",
    },
    Win3: {
      $ref: "#/components/schemas/GasBase",
    },
    Win4: {
      $ref: "#/components/schemas/GasBase",
    },
    Sum1: {
      $ref: "#/components/schemas/GasBase",
    },
    Sum2: {
      $ref: "#/components/schemas/GasBase",
    },
    Sum3: {
      $ref: "#/components/schemas/GasBase",
    },
    Sum4: {
      $ref: "#/components/schemas/GasBase",
    },
  },
  type: "object",
  required: [
    "DA",
    "WE",
    "M1",
    "M2",
    "M3",
    "Q1",
    "Q2",
    "Q3",
    "Q4",
    "Y1",
    "Y2",
    "Y3",
    "Y4",
    "Y5",
    "Win1",
    "Win2",
    "Win3",
    "Win4",
    "Sum1",
    "Sum2",
    "Sum3",
    "Sum4",
  ],
  title: "EstimatedGasPrices",
} as const;

export const $EstimatedPriceComparisonRecord = {
  properties: {
    gas: {
      items: {
        $ref: "#/components/schemas/GasContractComparison",
      },
      type: "array",
      title: "Gas",
    },
    electricity: {
      items: {
        $ref: "#/components/schemas/ElectricityContractComparison",
      },
      type: "array",
      title: "Electricity",
    },
    emissions: {
      items: {
        $ref: "#/components/schemas/EmissionsContractComparison",
      },
      type: "array",
      title: "Emissions",
    },
    sparkspread: {
      items: {
        $ref: "#/components/schemas/ElectricityContractComparison",
      },
      type: "array",
      title: "Sparkspread",
    },
    settlement_comparision_date: {
      anyOf: [
        {
          type: "string",
          format: "date",
        },
        {
          type: "null",
        },
      ],
      title: "Settlement Comparision Date",
    },
    price_update_comparison_date: {
      anyOf: [
        {
          type: "string",
          format: "date",
        },
        {
          type: "null",
        },
      ],
      title: "Price Update Comparison Date",
    },
  },
  type: "object",
  required: ["gas", "electricity", "emissions", "sparkspread"],
  title: "EstimatedPriceComparisonRecord",
} as const;

export const $EstimatedPriceUpdatePreferenceRecord_Input = {
  properties: {
    emissions: {
      $ref: "#/components/schemas/EstimatedEmissionPricePreferenceRecord",
    },
    gas: {
      $ref: "#/components/schemas/EstimatedGasPricePreferenceRecord",
    },
    electricity: {
      $ref: "#/components/schemas/EstimatedElectricityPricePreferenceRecord",
    },
    sparkspread: {
      $ref: "#/components/schemas/EstimatedSparkSpreadPricePreferenceRecord",
    },
  },
  type: "object",
  required: ["emissions", "gas", "electricity", "sparkspread"],
  title: "EstimatedPriceUpdatePreferenceRecord",
} as const;

export const $EstimatedPriceUpdatePreferenceRecord_Output = {
  properties: {
    emissions: {
      $ref: "#/components/schemas/EstimatedEmissionPricePreferenceRecord",
    },
    gas: {
      $ref: "#/components/schemas/EstimatedGasPricePreferenceRecord",
    },
    electricity: {
      $ref: "#/components/schemas/EstimatedElectricityPricePreferenceRecord",
    },
    sparkspread: {
      $ref: "#/components/schemas/EstimatedSparkSpreadPricePreferenceRecord",
    },
  },
  type: "object",
  required: ["emissions", "gas", "electricity", "sparkspread"],
  title: "EstimatedPriceUpdatePreferenceRecord",
} as const;

export const $EstimatedPriceUpdateRecord = {
  properties: {
    gas: {
      $ref: "#/components/schemas/EstimatedGasPrices",
    },
    electricity: {
      $ref: "#/components/schemas/EstimatedElectricityPrices",
    },
    emissions: {
      $ref: "#/components/schemas/EstimatedEmissionPrices",
    },
    sparkspread: {
      $ref: "#/components/schemas/EstimatedSparkSpreadPrices",
    },
  },
  type: "object",
  required: ["gas", "electricity", "emissions", "sparkspread"],
  title: "EstimatedPriceUpdateRecord",
} as const;

export const $EstimatedSparkSpreadPricePreference = {
  properties: {
    M1: {
      type: "boolean",
      title: "M1",
      default: false,
    },
    M2: {
      type: "boolean",
      title: "M2",
      default: false,
    },
    M3: {
      type: "boolean",
      title: "M3",
      default: false,
    },
    Q1: {
      type: "boolean",
      title: "Q1",
      default: false,
    },
    Q2: {
      type: "boolean",
      title: "Q2",
      default: false,
    },
    Q3: {
      type: "boolean",
      title: "Q3",
      default: false,
    },
    Q4: {
      type: "boolean",
      title: "Q4",
      default: false,
    },
    Y1: {
      type: "boolean",
      title: "Y1",
      default: false,
    },
    Y2: {
      type: "boolean",
      title: "Y2",
      default: false,
    },
    Y3: {
      type: "boolean",
      title: "Y3",
      default: false,
    },
    Y4: {
      type: "boolean",
      title: "Y4",
      default: false,
    },
  },
  type: "object",
  title: "EstimatedSparkSpreadPricePreference",
} as const;

export const $EstimatedSparkSpreadPricePreferenceRecord = {
  properties: {
    SPARKSPREAD_BASE_BID: {
      $ref: "#/components/schemas/EstimatedSparkSpreadPricePreference",
    },
    SPARKSPREAD_BASE_ASK: {
      $ref: "#/components/schemas/EstimatedSparkSpreadPricePreference",
    },
    SPARKSPREAD_PEAK_BID: {
      $ref: "#/components/schemas/EstimatedSparkSpreadPricePreference",
    },
    SPARKSPREAD_PEAK_ASK: {
      $ref: "#/components/schemas/EstimatedSparkSpreadPricePreference",
    },
    IS_LONG_HORIZON: {
      type: "boolean",
      title: "Is Long Horizon",
      default: false,
    },
  },
  type: "object",
  required: ["SPARKSPREAD_BASE_BID", "SPARKSPREAD_BASE_ASK", "SPARKSPREAD_PEAK_BID", "SPARKSPREAD_PEAK_ASK"],
  title: "EstimatedSparkSpreadPricePreferenceRecord",
} as const;

export const $EstimatedSparkSpreadPrices = {
  properties: {
    M1: {
      $ref: "#/components/schemas/SparkSpreadBase",
    },
    M2: {
      $ref: "#/components/schemas/SparkSpreadBase",
    },
    M3: {
      $ref: "#/components/schemas/SparkSpreadBase",
    },
    Q1: {
      $ref: "#/components/schemas/SparkSpreadBase",
    },
    Q2: {
      $ref: "#/components/schemas/SparkSpreadBase",
    },
    Q3: {
      $ref: "#/components/schemas/SparkSpreadBase",
    },
    Q4: {
      $ref: "#/components/schemas/SparkSpreadBase",
    },
    Y1: {
      $ref: "#/components/schemas/SparkSpreadBase",
    },
    Y2: {
      $ref: "#/components/schemas/SparkSpreadBase",
    },
    Y3: {
      $ref: "#/components/schemas/SparkSpreadBase",
    },
    Y4: {
      $ref: "#/components/schemas/SparkSpreadBase",
    },
  },
  type: "object",
  required: ["M1", "M2", "M3", "Q1", "Q2", "Q3", "Q4", "Y1", "Y2", "Y3", "Y4"],
  title: "EstimatedSparkSpreadPrices",
} as const;

export const $EtpaOrder = {
  properties: {
    xbidOrderId: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Xbidorderid",
    },
    id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Id",
    },
    orderType: {
      type: "string",
      title: "Ordertype",
    },
    xbidOrderType: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Xbidordertype",
    },
    participantId: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Participantid",
    },
    individualId: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Individualid",
    },
    capacity: {
      type: "number",
      title: "Capacity",
    },
    originalCapacity: {
      type: "number",
      title: "Originalcapacity",
    },
    created: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Created",
    },
    priority: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Priority",
    },
    deliveryStartTime: {
      type: "integer",
      title: "Deliverystarttime",
    },
    deliveryEndTime: {
      type: "integer",
      title: "Deliveryendtime",
    },
    unitPrice: {
      type: "number",
      title: "Unitprice",
    },
    customExpiration: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Customexpiration",
    },
    metadata: {
      anyOf: [
        {
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Metadata",
    },
    totalPrice: {
      type: "number",
      title: "Totalprice",
    },
    localViewDeliveryArea: {
      anyOf: [
        {
          type: "string",
        },
        {
          $ref: "#/components/schemas/OrderDeliveryArea",
        },
        {
          type: "null",
        },
      ],
      title: "Localviewdeliveryarea",
    },
    originatingDeliveryArea: {
      anyOf: [
        {
          type: "string",
        },
        {
          $ref: "#/components/schemas/OrderDeliveryArea",
        },
        {
          type: "null",
        },
      ],
      title: "Originatingdeliveryarea",
    },
    orderExecutionRestrictionType: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Orderexecutionrestrictiontype",
    },
    orderStatus: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Orderstatus",
    },
    revisionNo: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Revisionno",
    },
    allowedForLocalMarket: {
      type: "boolean",
      title: "Allowedforlocalmarket",
    },
    icebergDetails: {
      anyOf: [
        {
          $ref: "#/components/schemas/IcebergDetails",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: [
    "xbidOrderId",
    "id",
    "orderType",
    "xbidOrderType",
    "participantId",
    "individualId",
    "capacity",
    "originalCapacity",
    "created",
    "priority",
    "deliveryStartTime",
    "deliveryEndTime",
    "unitPrice",
    "customExpiration",
    "metadata",
    "totalPrice",
    "localViewDeliveryArea",
    "originatingDeliveryArea",
    "orderExecutionRestrictionType",
    "orderStatus",
    "revisionNo",
    "allowedForLocalMarket",
    "icebergDetails",
  ],
  title: "EtpaOrder",
} as const;

export const $EtpaOrderResponseModel = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/EtpaOrder",
      },
      type: "array",
      title: "Data",
    },
    auto_trader_order_count: {
      type: "integer",
      title: "Auto Trader Order Count",
    },
  },
  type: "object",
  required: ["data", "auto_trader_order_count"],
  title: "EtpaOrderResponseModel",
} as const;

export const $EtpaRepostAllOpenOrdersResponse = {
  properties: {
    success: {
      type: "boolean",
      title: "Success",
    },
    message: {
      type: "string",
      title: "Message",
    },
    posted_orders: {
      items: {
        $ref: "#/components/schemas/OrderDetails",
      },
      type: "array",
      title: "Posted Orders",
    },
    failed_orders: {
      items: {
        $ref: "#/components/schemas/OrderDetails",
      },
      type: "array",
      title: "Failed Orders",
    },
  },
  type: "object",
  required: ["success", "message", "posted_orders", "failed_orders"],
  title: "EtpaRepostAllOpenOrdersResponse",
} as const;

export const $GasBase = {
  properties: {
    contract: {
      type: "string",
      title: "Contract",
    },
    ttf_bid: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ttf Bid",
    },
    ttf_ask: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ttf Ask",
    },
  },
  type: "object",
  required: ["contract"],
  title: "GasBase",
} as const;

export const $GasContractCategories = {
  properties: {
    Months: {
      items: {
        $ref: "#/components/schemas/ContractRecord",
      },
      type: "array",
      title: "Months",
    },
    Quarters: {
      items: {
        $ref: "#/components/schemas/ContractRecord",
      },
      type: "array",
      title: "Quarters",
    },
    Years: {
      items: {
        $ref: "#/components/schemas/ContractRecord",
      },
      type: "array",
      title: "Years",
    },
    Winters: {
      items: {
        $ref: "#/components/schemas/ContractRecord",
      },
      type: "array",
      title: "Winters",
    },
    Summers: {
      items: {
        $ref: "#/components/schemas/ContractRecord",
      },
      type: "array",
      title: "Summers",
    },
  },
  type: "object",
  required: ["Months", "Quarters", "Years", "Winters", "Summers"],
  title: "GasContractCategories",
} as const;

export const $GasContractComparison = {
  properties: {
    contract: {
      type: "string",
      title: "Contract",
    },
    ttf_bid: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ttf Bid",
    },
    ttf_ask: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ttf Ask",
    },
    settlement_price: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Settlement Price",
    },
    previous_ttf_bid: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Previous Ttf Bid",
    },
    previous_ttf_ask: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Previous Ttf Ask",
    },
  },
  type: "object",
  required: ["contract", "ttf_bid", "ttf_ask", "settlement_price"],
  title: "GasContractComparison",
} as const;

export const $GasPricePreference = {
  properties: {
    DA: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    WE: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    M1: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    M2: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    M3: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Q1: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Q2: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Q3: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Q4: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Y1: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Y2: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Y3: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Y4: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Y5: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Win1: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Win2: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Win3: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Win4: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Sum1: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Sum2: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Sum3: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Sum4: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  title: "GasPricePreference",
} as const;

export const $GetPriceUpdateDataByDateResponse = {
  properties: {
    data: {
      $ref: "#/components/schemas/EstimatedPriceUpdateRecord",
    },
    date: {
      type: "string",
      format: "date",
      title: "Date",
    },
    sent_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Sent At",
    },
    created_at: {
      type: "string",
      format: "date-time",
      title: "Created At",
    },
    updated_at: {
      type: "string",
      format: "date-time",
      title: "Updated At",
    },
  },
  type: "object",
  required: ["data", "date", "sent_at", "created_at", "updated_at"],
  title: "GetPriceUpdateDataByDateResponse",
} as const;

export const $HTTPValidationError = {
  properties: {
    detail: {
      items: {
        $ref: "#/components/schemas/ValidationError",
      },
      type: "array",
      title: "Detail",
    },
  },
  type: "object",
  title: "HTTPValidationError",
} as const;

export const $IcebergDetails = {
  properties: {
    showCapacity: {
      type: "number",
      title: "Showcapacity",
    },
    pricePerDelta: {
      type: "number",
      title: "Priceperdelta",
    },
    hiddenCapacity: {
      type: "number",
      title: "Hiddencapacity",
    },
    originalUnitPrice: {
      type: "number",
      title: "Originalunitprice",
    },
  },
  type: "object",
  required: ["showCapacity", "pricePerDelta", "hiddenCapacity", "originalUnitPrice"],
  title: "IcebergDetails",
} as const;

export const $InnovaAlgoTrade = {
  properties: {
    Id: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Id",
    },
    DeliveryDate: {
      type: "string",
      format: "date",
      title: "Deliverydate",
    },
    Start: {
      type: "string",
      format: "time",
      title: "Start",
    },
    End: {
      type: "string",
      format: "time",
      title: "End",
    },
    Side: {
      type: "string",
      title: "Side",
    },
    Volume: {
      type: "string",
      title: "Volume",
    },
    IntradayCode: {
      type: "string",
      title: "Intradaycode",
    },
    OrderVolume: {
      type: "string",
      title: "Ordervolume",
    },
    TargetTime: {
      type: "string",
      format: "date-time",
      title: "Targettime",
    },
    PriceLimit: {
      type: "string",
      title: "Pricelimit",
    },
    SliceId: {
      type: "string",
      title: "Sliceid",
    },
    OrderId: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Orderid",
    },
    Status: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Status",
    },
    FilledVolume: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Filledvolume",
    },
    FilledPrice: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Filledprice",
    },
    FilledAt: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Filledat",
    },
    CreatedAt: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Createdat",
    },
    UpdatedAt: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Updatedat",
    },
  },
  type: "object",
  required: [
    "DeliveryDate",
    "Start",
    "End",
    "Side",
    "Volume",
    "IntradayCode",
    "OrderVolume",
    "TargetTime",
    "PriceLimit",
    "SliceId",
  ],
  title: "InnovaAlgoTrade",
} as const;

export const $InnovaSignal = {
  properties: {
    Id: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Id",
    },
    DeliveryDate: {
      type: "string",
      format: "date",
      title: "Deliverydate",
    },
    Start: {
      type: "string",
      format: "time",
      title: "Start",
    },
    End: {
      type: "string",
      format: "time",
      title: "End",
    },
    Side: {
      type: "string",
      title: "Side",
    },
    Volume: {
      type: "string",
      title: "Volume",
    },
    PriceLimit: {
      type: "string",
      title: "Pricelimit",
    },
    IntradayCode: {
      type: "integer",
      title: "Intradaycode",
    },
    Source: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Source",
    },
    LastUpdate: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Lastupdate",
    },
    Algo: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Algo",
      default: 0,
    },
    CreatedAt: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Createdat",
    },
    UpdatedAt: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Updatedat",
    },
  },
  type: "object",
  required: ["Id", "DeliveryDate", "Start", "End", "Side", "Volume", "PriceLimit", "IntradayCode"],
  title: "InnovaSignal",
} as const;

export const $LimitCheckResult = {
  properties: {
    limit_name: {
      type: "string",
      enum: ["MaxTradeVolumeMwhPerPtu", "MaxHourlyVolumeMwh", "MaxDailyVolumeMwh", "DayNotionalCapEur", "PriceDelta"],
      title: "Limit Name",
    },
    delivery_date: {
      type: "string",
      format: "date",
      title: "Delivery Date",
    },
    enabled: {
      type: "boolean",
      title: "Enabled",
    },
    worst: {
      anyOf: [
        {
          $ref: "#/components/schemas/LimitMeasurement",
        },
        {
          type: "null",
        },
      ],
    },
    breaches: {
      items: {
        $ref: "#/components/schemas/LimitMeasurement",
      },
      type: "array",
      title: "Breaches",
    },
  },
  type: "object",
  required: ["limit_name", "delivery_date", "enabled", "worst", "breaches"],
  title: "LimitCheckResult",
  description: `One check on one delivery date. worst is the measurement with the
largest actual âˆ’ limit, None when nothing was measured or the check is
off (enabled False).`,
} as const;

export const $LimitMeasurement = {
  properties: {
    limit_name: {
      type: "string",
      enum: ["MaxTradeVolumeMwhPerPtu", "MaxHourlyVolumeMwh", "MaxDailyVolumeMwh", "DayNotionalCapEur", "PriceDelta"],
      title: "Limit Name",
    },
    delivery_date: {
      type: "string",
      format: "date",
      title: "Delivery Date",
    },
    start: {
      anyOf: [
        {
          type: "string",
          format: "time",
        },
        {
          type: "null",
        },
      ],
      title: "Start",
    },
    end: {
      anyOf: [
        {
          type: "string",
          format: "time",
        },
        {
          type: "null",
        },
      ],
      title: "End",
    },
    actual: {
      type: "string",
      title: "Actual",
    },
    limit: {
      type: "string",
      title: "Limit",
    },
    limit_price: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Limit Price",
    },
    day_ahead_price: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Day Ahead Price",
    },
  },
  type: "object",
  required: ["limit_name", "delivery_date", "start", "end", "actual", "limit"],
  title: "LimitMeasurement",
  description: `One measured value against its limit, for one PTU, clock hour or
delivery date.

start/end are None when the measurement covers the whole delivery date.
For the price checks, actual is the gap between limit price and Day Ahead
price and limit is the allowed gap, both in EUR/MWh; limit_price and
day_ahead_price are the two prices compared (None for the other checks).`,
} as const;

export const $ListOfPriceItems = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/PriceItem",
      },
      type: "array",
      title: "Data",
    },
  },
  type: "object",
  required: ["data"],
  title: "ListOfPriceItems",
} as const;

export const $Message = {
  properties: {
    message: {
      type: "string",
      title: "Message",
    },
  },
  type: "object",
  required: ["message"],
  title: "Message",
} as const;

export const $ORDERS_SU2M = {
  properties: {
    orderId: {
      type: "string",
      title: "Orderid",
    },
    intradayCode: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Intradaycode",
    },
    locId: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Locid",
    },
    componentId: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Componentid",
    },
    date: {
      anyOf: [
        {
          type: "string",
          format: "date",
        },
        {
          type: "null",
        },
      ],
      title: "Date",
    },
    hour: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Hour",
    },
    quarter: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Quarter",
    },
    orderType: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Ordertype",
    },
    volumeAbs: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Volumeabs",
    },
    volume: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Volume",
    },
    limitPrice: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Limitprice",
    },
    orderIdETPA: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Orderidetpa",
    },
    orderEntryTime: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Orderentrytime",
    },
    statusBCI: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Statusbci",
    },
    statusSU2M: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Statussu2M",
    },
  },
  type: "object",
  required: [
    "orderId",
    "intradayCode",
    "locId",
    "componentId",
    "date",
    "hour",
    "quarter",
    "orderType",
    "volumeAbs",
    "volume",
    "limitPrice",
    "orderIdETPA",
    "orderEntryTime",
    "statusBCI",
    "statusSU2M",
  ],
  title: "ORDERS_SU2M",
} as const;

export const $OrderDeliveryArea = {
  properties: {
    country: {
      type: "string",
      title: "Country",
    },
    eic: {
      type: "string",
      title: "Eic",
    },
    area: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Area",
    },
  },
  type: "object",
  required: ["country", "eic"],
  title: "OrderDeliveryArea",
} as const;

export const $OrderDetails = {
  properties: {
    order_id: {
      type: "string",
      title: "Order Id",
    },
    message: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Message",
    },
    order_id_etpa: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Order Id Etpa",
    },
    success: {
      type: "boolean",
      title: "Success",
    },
  },
  type: "object",
  required: ["order_id", "success"],
  title: "OrderDetails",
} as const;

export const $OrdersSu2mResponseModel = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/ORDERS_SU2M",
      },
      type: "array",
      title: "Data",
    },
  },
  type: "object",
  required: ["data"],
  title: "OrdersSu2mResponseModel",
} as const;

export const $OverrideTradingLimitsRequest = {
  properties: {
    delivery_date: {
      type: "string",
      format: "date",
      title: "Delivery Date",
    },
    limits: {
      $ref: "#/components/schemas/TradingLimits-Input",
    },
  },
  type: "object",
  required: ["delivery_date", "limits"],
  title: "OverrideTradingLimitsRequest",
} as const;

export const $PTU_Identifier = {
  properties: {
    delivery_date: {
      type: "string",
      format: "date",
      title: "Delivery Date",
    },
    start_time: {
      type: "string",
      format: "time",
      title: "Start Time",
    },
    end_time: {
      type: "string",
      format: "time",
      title: "End Time",
    },
    intraday_code: {
      type: "string",
      title: "Intraday Code",
    },
  },
  type: "object",
  required: ["delivery_date", "start_time", "end_time", "intraday_code"],
  title: "PTU_Identifier",
} as const;

export const $PermissionsEnum = {
  type: "string",
  enum: ["clientsheet:read", "invoice:read", "sparkspread:read", "pricesheet:read", "price_update:write"],
  title: "PermissionsEnum",
} as const;

export const $PriceItem = {
  properties: {
    Timestamp: {
      type: "integer",
      title: "Timestamp",
    },
    Rel_code: {
      type: "string",
      title: "Rel Code",
    },
    Period: {
      type: "string",
      title: "Period",
    },
    Product: {
      type: "string",
      title: "Product",
    },
    Price: {
      type: "number",
      title: "Price",
    },
    source_type: {
      type: "string",
      enum: ["settlement", "realistic"],
      title: "Source Type",
    },
  },
  type: "object",
  required: ["Timestamp", "Rel_code", "Period", "Product", "Price", "source_type"],
  title: "PriceItem",
} as const;

export const $PriceUpdateEmailDataInput = {
  properties: {
    emissions: {
      anyOf: [
        {
          $ref: "#/components/schemas/EmissionsPricePreference",
        },
        {
          type: "null",
        },
      ],
    },
    gas_ttf_bid: {
      anyOf: [
        {
          $ref: "#/components/schemas/GasPricePreference",
        },
        {
          type: "null",
        },
      ],
    },
    gas_ttf_ask: {
      anyOf: [
        {
          $ref: "#/components/schemas/GasPricePreference",
        },
        {
          type: "null",
        },
      ],
    },
    electricity_nl_base_bid: {
      anyOf: [
        {
          $ref: "#/components/schemas/ElectricityPricePreference",
        },
        {
          type: "null",
        },
      ],
    },
    electricity_nl_base_ask: {
      anyOf: [
        {
          $ref: "#/components/schemas/ElectricityPricePreference",
        },
        {
          type: "null",
        },
      ],
    },
    electricity_nl_peak_bid: {
      anyOf: [
        {
          $ref: "#/components/schemas/ElectricityPricePreference",
        },
        {
          type: "null",
        },
      ],
    },
    electricity_nl_peak_ask: {
      anyOf: [
        {
          $ref: "#/components/schemas/ElectricityPricePreference",
        },
        {
          type: "null",
        },
      ],
    },
    sparkspread_base_bid: {
      anyOf: [
        {
          $ref: "#/components/schemas/SparkSpreadPricePreference",
        },
        {
          type: "null",
        },
      ],
    },
    sparkspread_base_ask: {
      anyOf: [
        {
          $ref: "#/components/schemas/SparkSpreadPricePreference",
        },
        {
          type: "null",
        },
      ],
    },
    sparkspread_peak_bid: {
      anyOf: [
        {
          $ref: "#/components/schemas/SparkSpreadPricePreference",
        },
        {
          type: "null",
        },
      ],
    },
    sparkspread_peak_ask: {
      anyOf: [
        {
          $ref: "#/components/schemas/SparkSpreadPricePreference",
        },
        {
          type: "null",
        },
      ],
    },
    settlement_date: {
      type: "string",
      format: "date",
      title: "Settlement Date",
    },
  },
  type: "object",
  required: ["settlement_date"],
  title: "PriceUpdateEmailDataInput",
} as const;

export const $PriceUpdateEmailDataInputRow = {
  properties: {
    contract_name: {
      type: "string",
      title: "Contract Name",
    },
    price: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Price",
    },
    price_change_percentage: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Price Change Percentage",
    },
    price_change_in_eur: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Price Change In Eur",
    },
    direction: {
      anyOf: [
        {
          type: "string",
          enum: ["up", "down", "neutral"],
        },
        {
          type: "null",
        },
      ],
      title: "Direction",
    },
  },
  type: "object",
  required: ["contract_name"],
  title: "PriceUpdateEmailDataInputRow",
} as const;

export const $RunSummary = {
  properties: {
    last_update: {
      type: "string",
      format: "date-time",
      title: "Last Update",
    },
    intraday_code: {
      type: "integer",
      title: "Intraday Code",
    },
    source: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Source",
    },
    signal_count: {
      type: "integer",
      title: "Signal Count",
    },
    delivery_date_min: {
      type: "string",
      format: "date",
      title: "Delivery Date Min",
    },
    delivery_date_max: {
      type: "string",
      format: "date",
      title: "Delivery Date Max",
    },
    total_buy_mwh: {
      type: "string",
      title: "Total Buy Mwh",
    },
    total_sell_mwh: {
      type: "string",
      title: "Total Sell Mwh",
    },
    algo_off: {
      type: "integer",
      title: "Algo Off",
    },
    algo_ready: {
      type: "integer",
      title: "Algo Ready",
    },
    algo_built: {
      type: "integer",
      title: "Algo Built",
    },
    created_at: {
      type: "string",
      format: "date-time",
      title: "Created At",
    },
  },
  type: "object",
  required: [
    "last_update",
    "intraday_code",
    "source",
    "signal_count",
    "delivery_date_min",
    "delivery_date_max",
    "total_buy_mwh",
    "total_sell_mwh",
    "algo_off",
    "algo_ready",
    "algo_built",
    "created_at",
  ],
  title: "RunSummary",
} as const;

export const $RunsResponseModel = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/RunSummary",
      },
      type: "array",
      title: "Data",
    },
    total: {
      type: "integer",
      title: "Total",
    },
  },
  type: "object",
  required: ["data", "total"],
  title: "RunsResponseModel",
} as const;

export const $SignalsResponseModel = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/InnovaSignal",
      },
      type: "array",
      title: "Data",
    },
  },
  type: "object",
  required: ["data"],
  title: "SignalsResponseModel",
} as const;

export const $SlicesResponseModel = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/InnovaAlgoTrade",
      },
      type: "array",
      title: "Data",
    },
  },
  type: "object",
  required: ["data"],
  title: "SlicesResponseModel",
} as const;

export const $SparkSpreadBase = {
  properties: {
    contract: {
      type: "string",
      title: "Contract",
    },
    sparkspread_base_bid: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Sparkspread Base Bid",
    },
    sparkspread_base_ask: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Sparkspread Base Ask",
    },
    sparkspread_peak_bid: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Sparkspread Peak Bid",
    },
    sparkspread_peak_ask: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Sparkspread Peak Ask",
    },
  },
  type: "object",
  required: ["contract"],
  title: "SparkSpreadBase",
} as const;

export const $SparkSpreadContractCategoriesByProduct = {
  properties: {
    SpSpBase: {
      $ref: "#/components/schemas/ElectricityContractCategories",
    },
    SpSpPeak: {
      $ref: "#/components/schemas/ElectricityContractCategories",
    },
  },
  type: "object",
  required: ["SpSpBase", "SpSpPeak"],
  title: "SparkSpreadContractCategoriesByProduct",
} as const;

export const $SparkSpreadPricePreference = {
  properties: {
    M1: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    M2: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    M3: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Q1: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Q2: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Q3: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Q4: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Y1: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Y2: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Y3: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
    Y4: {
      anyOf: [
        {
          $ref: "#/components/schemas/PriceUpdateEmailDataInputRow",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  title: "SparkSpreadPricePreference",
} as const;

export const $SuperUserPermissionsEnum = {
  type: "string",
  enum: ["user-management", "price-update", "auto-trader", "algo-trading", "superuser-management"],
  title: "SuperUserPermissionsEnum",
} as const;

export const $SyncClientsResponse = {
  properties: {
    created_clients: {
      items: {
        $ref: "#/components/schemas/ClientPublic",
      },
      type: "array",
      title: "Created Clients",
    },
    updated_clients: {
      items: {
        $ref: "#/components/schemas/ClientPublic",
      },
      type: "array",
      title: "Updated Clients",
    },
  },
  type: "object",
  required: ["created_clients", "updated_clients"],
  title: "SyncClientsResponse",
} as const;

export const $TradingLimitCheck = {
  properties: {
    results: {
      items: {
        $ref: "#/components/schemas/LimitCheckResult",
      },
      type: "array",
      title: "Results",
    },
    missing_day_ahead_prices: {
      items: {
        $ref: "#/components/schemas/PTU_Identifier",
      },
      type: "array",
      title: "Missing Day Ahead Prices",
    },
    passed: {
      type: "boolean",
      title: "Passed",
      readOnly: true,
    },
  },
  type: "object",
  required: ["results", "missing_day_ahead_prices", "passed"],
  title: "TradingLimitCheck",
} as const;

export const $TradingLimits_Input = {
  properties: {
    max_trade_volume_mwh_per_ptu: {
      anyOf: [
        {
          type: "number",
          minimum: 0,
        },
        {
          type: "string",
        },
      ],
      title: "ID max trade volume (MWh/PTU)",
    },
    max_hourly_volume_mwh: {
      anyOf: [
        {
          type: "number",
          minimum: 0,
        },
        {
          type: "string",
        },
      ],
      title: "ID max hourly volume (MWh)",
    },
    max_daily_volume_mwh: {
      anyOf: [
        {
          type: "number",
          minimum: 0,
        },
        {
          type: "string",
        },
      ],
      title: "ID max daily trade volume (MWh)",
    },
    day_notional_cap_eur: {
      anyOf: [
        {
          type: "number",
          minimum: 0,
        },
        {
          type: "string",
        },
      ],
      title: "Day notional cap (EUR)",
    },
    price_delta_eur: {
      anyOf: [
        {
          type: "number",
          minimum: 0,
        },
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Price delta (EUR)",
    },
    price_delta_percent: {
      anyOf: [
        {
          type: "number",
          minimum: 0,
        },
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Price delta (% EPEX)",
    },
    minutes_to_closed_id: {
      type: "integer",
      minimum: 0,
      title: "Minutes to closed ID",
    },
  },
  type: "object",
  required: [
    "max_trade_volume_mwh_per_ptu",
    "max_hourly_volume_mwh",
    "max_daily_volume_mwh",
    "day_notional_cap_eur",
    "price_delta_eur",
    "price_delta_percent",
    "minutes_to_closed_id",
  ],
  title: "TradingLimits",
  description: `Effective limits for one delivery date: default or that day's override.
Titles are the names Innova and Tim use. A None price delta turns that
check off.`,
} as const;

export const $TradingLimits_Output = {
  properties: {
    max_trade_volume_mwh_per_ptu: {
      type: "string",
      title: "ID max trade volume (MWh/PTU)",
    },
    max_hourly_volume_mwh: {
      type: "string",
      title: "ID max hourly volume (MWh)",
    },
    max_daily_volume_mwh: {
      type: "string",
      title: "ID max daily trade volume (MWh)",
    },
    day_notional_cap_eur: {
      type: "string",
      title: "Day notional cap (EUR)",
    },
    price_delta_eur: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Price delta (EUR)",
    },
    price_delta_percent: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Price delta (% EPEX)",
    },
    minutes_to_closed_id: {
      type: "integer",
      minimum: 0,
      title: "Minutes to closed ID",
    },
  },
  type: "object",
  required: [
    "max_trade_volume_mwh_per_ptu",
    "max_hourly_volume_mwh",
    "max_daily_volume_mwh",
    "day_notional_cap_eur",
    "price_delta_eur",
    "price_delta_percent",
    "minutes_to_closed_id",
  ],
  title: "TradingLimits",
  description: `Effective limits for one delivery date: default or that day's override.
Titles are the names Innova and Tim use. A None price delta turns that
check off.`,
} as const;

export const $TradingLimitsResponse = {
  properties: {
    delivery_date: {
      type: "string",
      format: "date",
      title: "Delivery Date",
    },
    default: {
      $ref: "#/components/schemas/TradingLimits-Output",
    },
    effective: {
      $ref: "#/components/schemas/TradingLimits-Output",
    },
    overridden_by: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Overridden By",
    },
    overridden_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Overridden At",
    },
    usage: {
      $ref: "#/components/schemas/TradingLimitCheck",
      description: "The checks on the live signals (Algo 1/2) of this date",
    },
  },
  type: "object",
  required: ["delivery_date", "default", "effective", "overridden_by", "overridden_at", "usage"],
  title: "TradingLimitsResponse",
} as const;

export const $TransformPriceUpdateEmailDataResponse = {
  properties: {
    email_input: {
      $ref: "#/components/schemas/PriceUpdateEmailDataInput",
    },
    raw_comparision: {
      $ref: "#/components/schemas/EstimatedPriceComparisonRecord",
    },
  },
  type: "object",
  required: ["email_input", "raw_comparision"],
  title: "TransformPriceUpdateEmailDataResponse",
} as const;

export const $UpdateAlgoRequest = {
  properties: {
    ids: {
      items: {
        type: "integer",
      },
      type: "array",
      minItems: 1,
      title: "Ids",
    },
    algo: {
      type: "integer",
      enum: [0, 1],
      title: "Algo",
    },
  },
  type: "object",
  required: ["ids", "algo"],
  title: "UpdateAlgoRequest",
} as const;

export const $UpdateAlgoResponse = {
  properties: {
    updated: {
      type: "integer",
      title: "Updated",
    },
  },
  type: "object",
  required: ["updated"],
  title: "UpdateAlgoResponse",
} as const;

export const $UserBase = {
  properties: {
    email: {
      type: "string",
      maxLength: 255,
      format: "email",
      title: "Email",
    },
    is_active: {
      type: "boolean",
      title: "Is Active",
      default: true,
    },
    is_superuser: {
      type: "boolean",
      title: "Is Superuser",
      default: false,
    },
    first_name: {
      anyOf: [
        {
          type: "string",
          maxLength: 255,
        },
        {
          type: "null",
        },
      ],
      title: "First Name",
    },
    last_name: {
      anyOf: [
        {
          type: "string",
          maxLength: 255,
        },
        {
          type: "null",
        },
      ],
      title: "Last Name",
    },
    last_login_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Last Login At",
    },
  },
  type: "object",
  required: ["email"],
  title: "UserBase",
} as const;

export const $UserClientPermissionDetail = {
  properties: {
    email: {
      type: "string",
      maxLength: 255,
      format: "email",
      title: "Email",
    },
    is_active: {
      type: "boolean",
      title: "Is Active",
      default: true,
    },
    is_superuser: {
      type: "boolean",
      title: "Is Superuser",
      default: false,
    },
    first_name: {
      anyOf: [
        {
          type: "string",
          maxLength: 255,
        },
        {
          type: "null",
        },
      ],
      title: "First Name",
    },
    last_name: {
      anyOf: [
        {
          type: "string",
          maxLength: 255,
        },
        {
          type: "null",
        },
      ],
      title: "Last Name",
    },
    last_login_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Last Login At",
    },
    id: {
      type: "integer",
      title: "Id",
    },
    created_at: {
      type: "string",
      format: "date-time",
      title: "Created At",
    },
    updated_at: {
      type: "string",
      format: "date-time",
      title: "Updated At",
    },
    client_id: {
      type: "integer",
      title: "Client Id",
    },
    client_code: {
      type: "string",
      title: "Client Code",
    },
    client_name: {
      type: "string",
      title: "Client Name",
    },
    permissions: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Permissions",
    },
    estimated_price_update_preferences: {
      anyOf: [
        {
          $ref: "#/components/schemas/EstimatedPriceUpdatePreferenceRecord-Output",
        },
        {
          type: "null",
        },
      ],
    },
    cc_recipients: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Cc Recipients",
    },
    bcc_recipients: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Bcc Recipients",
    },
  },
  type: "object",
  required: [
    "email",
    "id",
    "created_at",
    "updated_at",
    "client_id",
    "client_code",
    "client_name",
    "permissions",
    "estimated_price_update_preferences",
    "cc_recipients",
    "bcc_recipients",
  ],
  title: "UserClientPermissionDetail",
} as const;

export const $UserPublic = {
  properties: {
    email: {
      type: "string",
      maxLength: 255,
      format: "email",
      title: "Email",
    },
    is_active: {
      type: "boolean",
      title: "Is Active",
      default: true,
    },
    is_superuser: {
      type: "boolean",
      title: "Is Superuser",
      default: false,
    },
    first_name: {
      anyOf: [
        {
          type: "string",
          maxLength: 255,
        },
        {
          type: "null",
        },
      ],
      title: "First Name",
    },
    last_name: {
      anyOf: [
        {
          type: "string",
          maxLength: 255,
        },
        {
          type: "null",
        },
      ],
      title: "Last Name",
    },
    last_login_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Last Login At",
    },
    id: {
      type: "integer",
      title: "Id",
    },
    created_at: {
      type: "string",
      format: "date-time",
      title: "Created At",
    },
    updated_at: {
      type: "string",
      format: "date-time",
      title: "Updated At",
    },
  },
  type: "object",
  required: ["email", "id", "created_at", "updated_at"],
  title: "UserPublic",
} as const;

export const $UserPublicWithClientLinks = {
  properties: {
    email: {
      type: "string",
      maxLength: 255,
      format: "email",
      title: "Email",
    },
    is_active: {
      type: "boolean",
      title: "Is Active",
      default: true,
    },
    is_superuser: {
      type: "boolean",
      title: "Is Superuser",
      default: false,
    },
    first_name: {
      anyOf: [
        {
          type: "string",
          maxLength: 255,
        },
        {
          type: "null",
        },
      ],
      title: "First Name",
    },
    last_name: {
      anyOf: [
        {
          type: "string",
          maxLength: 255,
        },
        {
          type: "null",
        },
      ],
      title: "Last Name",
    },
    last_login_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Last Login At",
    },
    id: {
      type: "integer",
      title: "Id",
    },
    created_at: {
      type: "string",
      format: "date-time",
      title: "Created At",
    },
    updated_at: {
      type: "string",
      format: "date-time",
      title: "Updated At",
    },
    client_links: {
      items: {
        $ref: "#/components/schemas/ClientLinkCreate-Output",
      },
      type: "array",
      title: "Client Links",
    },
    clients: {
      items: {
        $ref: "#/components/schemas/ClientPublic",
      },
      type: "array",
      title: "Clients",
    },
  },
  type: "object",
  required: ["email", "id", "created_at", "updated_at", "client_links", "clients"],
  title: "UserPublicWithClientLinks",
} as const;

export const $UserUpdate = {
  properties: {
    email: {
      anyOf: [
        {
          type: "string",
          maxLength: 255,
          format: "email",
        },
        {
          type: "null",
        },
      ],
      title: "Email",
    },
    is_active: {
      type: "boolean",
      title: "Is Active",
      default: true,
    },
    is_superuser: {
      type: "boolean",
      title: "Is Superuser",
      default: false,
    },
    first_name: {
      anyOf: [
        {
          type: "string",
          maxLength: 255,
        },
        {
          type: "null",
        },
      ],
      title: "First Name",
    },
    last_name: {
      anyOf: [
        {
          type: "string",
          maxLength: 255,
        },
        {
          type: "null",
        },
      ],
      title: "Last Name",
    },
    last_login_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Last Login At",
    },
    password: {
      anyOf: [
        {
          type: "string",
          maxLength: 40,
          minLength: 8,
        },
        {
          type: "null",
        },
      ],
      title: "Password",
    },
  },
  type: "object",
  title: "UserUpdate",
} as const;

export const $UsersClientsPermissions = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/UserClientPermissionDetail",
      },
      type: "array",
      title: "Data",
    },
  },
  type: "object",
  required: ["data"],
  title: "UsersClientsPermissions",
} as const;

export const $UsersWithClientLinks = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/UserPublicWithClientLinks",
      },
      type: "array",
      title: "Data",
    },
    count: {
      type: "integer",
      title: "Count",
    },
  },
  type: "object",
  required: ["data", "count"],
  title: "UsersWithClientLinks",
} as const;

export const $ValidationError = {
  properties: {
    loc: {
      items: {
        anyOf: [
          {
            type: "string",
          },
          {
            type: "integer",
          },
        ],
      },
      type: "array",
      title: "Location",
    },
    msg: {
      type: "string",
      title: "Message",
    },
    type: {
      type: "string",
      title: "Error Type",
    },
  },
  type: "object",
  required: ["loc", "msg", "type"],
  title: "ValidationError",
} as const;

export const $WorkerStateResponse = {
  properties: {
    status: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Status",
    },
    run_number: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Run Number",
    },
    created_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Created At",
    },
    latest_portal_command: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Latest Portal Command",
    },
    latest_portal_command_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Latest Portal Command At",
    },
  },
  type: "object",
  required: ["status", "run_number", "created_at", "latest_portal_command", "latest_portal_command_at"],
  title: "WorkerStateResponse",
} as const;
